import { patchActivateClientUserAsync } from 'API/clients/patchActivateClientUserAsync';
import { patchDeactivateClientUserAsync } from 'API/clients/patchDeactivateClientUserAsync';
import { createAsyncSlice } from 'store/createAsyncSlice';

export const { slice: activateClientUserAuthAccountSlice, asyncAction: patchActivateClientUserAsyncAction } =
  createAsyncSlice('activateClientUserAuthAccountSlice', patchActivateClientUserAsync);
export const { slice: deactivateClientUserAuthAccountSlice, asyncAction: patchDeactivateClientUserAsyncAction } =
  createAsyncSlice('deactivateClientUserAuthAccountSlice', patchDeactivateClientUserAsync);
